export { default as ENDPOINTS } from './paths'
export { get, put, post, del, mock } from './request'
